import * as yup from "yup";
import {
  createRequiredTrimmedString,
  createRichTextRequiredSchema,
} from "./schemaUtils";

export const schema = yup.object({
    subject: createRequiredTrimmedString("subject is required"),
    message: createRichTextRequiredSchema("Description is required"),
  });
